module.exports = __webpack_public_path__ + "media/images/wedding/thumb/22-de5d34f3af362c2ed4620e519d627535.jpg";